import {
  ApolloError,
  gql,
  useMutation,
} from "@apollo/client";
import {
  ToggleInterestMutationMutation,
  ToggleInterestMutationMutationVariables,
} from "../../../../schemaTypes";
import { NormalizedErrorMap } from "../../../../types/NormalizedErrorMap";
import { normalizeErrors } from "../../../../utils/normalizeErrors";

export const toggleInterestMutation = gql`
  mutation ToggleInterestMutation(
    $merchantUserId: String!
  ) {
    toggleInterest(
      merchantUserId: $merchantUserId
    ) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  onMessage?: (message: string) => void;
  children: (
    data: {
      submit: (
        values: ToggleInterestMutationMutationVariables
      ) => Promise<{
        errors: NormalizedErrorMap | null;
        message?: string;
      }>;
      loading: boolean;
      error?: ApolloError;
    }
  ) => React.ReactElement | null;
}

export const ToggleInterestController: React.FC<Props> = ({
  children,
  onMessage,
}) => {
  const [toggleInterestMutationFn, { loading, error }] =
    useMutation<
      ToggleInterestMutationMutation,
      ToggleInterestMutationMutationVariables
    >(toggleInterestMutation);

  const submit = async (
    values: ToggleInterestMutationMutationVariables
  ) => {
    const response = await toggleInterestMutationFn({
      variables: values,
    });

    const data = response.data?.toggleInterest;

    const errors = data?.errors
      ? normalizeErrors(data.errors)
      : null;

    if (data?.message && onMessage) {
      onMessage(data.message);
    }

    return {
      errors,
      message: data?.message ?? undefined,
    };
  };

  return children({ submit, loading, error });
};